<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span> Update Admin Lead Details</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="leadDetailsForm" (submit)="saveLeadDetails()">
                <div class="card-body">
                    <div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
                    <div class="row" *ngIf="dataLoaded">
                        <div class="container-fluid">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Lead Source*</label>
                                            <mat-select placeholder="Lead Source" formControlName="lead_source"
                                                (click)="setSearchValue('lead_source')">
                                                <input class="mySearchInput" #leadsourceSearch focused="'true'"
                                                    type="text"
                                                    (keyup)="searchOnSelect($event.target.value, 'lead_source')"
                                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                                    placeholder="Search" id="leadsourceSearch">
                                                <mat-option [value]="lsources.id"
                                                    *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                                            </mat-select>
                                            <div *ngIf="submitted && f.lead_source.errors" class="invalid-feedback">
                                                <div *ngIf="f.lead_source.errors.required">Lead source is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Bridge Number</label>
                                            <mat-select placeholder="Bridge Number" formControlName="bridgeno"
                                                (click)="setSearchValue('bridgeno')">
                                                <input class="mySearchInput" #bridgenoSearch focused="'true'"
                                                    type="text"
                                                    (keyup)="searchOnSelect($event.target.value, 'bridgeno')"
                                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                                    placeholder="Search" id="bridgenoSearch">
                                                <mat-option [value]="bnumbers.bridge_number"
                                                    *ngFor="let bnumbers of bridge_number_lists">{{bnumbers.bridge_number}}
                                                    ({{bnumbers.bridge_name}})</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label>Keywords</label>
                                            <input class="form-control" formControlName="keywords"
                                                placeholder="Keywords" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Update</span>
                    </button>
                </div>
            </form>

        </div>

    </div>
</div>